import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { useNavigate } from 'react-router';
import urljoin from 'url-join';
import { Controller, onDidMount } from '../decorators';
import { useController } from '../hooks';
import { Reflector } from '../reflection';

function _isArrayOfArrays(value) {
  return value.length > 0 && Array.isArray(value[0]);
}

export function createRoute(path, Controller) {
  var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (Array.isArray(Controller)) {
    children = Controller;
    return children.flat().map(function (c) {
      return _objectSpread(_objectSpread({}, c), {}, {
        path: urljoin(path, c.path)
      });
    });
  }

  return _isArrayOfArrays(children) ? {
    path: path,
    Controller: Controller,
    children: children.flat()
  } : {
    path: path,
    Controller: Controller,
    children: children
  };
}
export function includeRoutes(basepath, SubApp) {
  var _Reflector$getSubAppM = Reflector.getSubAppMetadata(SubApp),
      routing = _Reflector$getSubAppM.routing;

  return routing.map(function (route) {
    return _objectSpread(_objectSpread({}, route), {}, {
      path: urljoin(basepath, route.path)
    });
  });
}
export function createRedirection(from, to) {
  var RedirectionView = function RedirectionView() {
    useController();
    return null;
  };

  var RedirectionController = /*#__PURE__*/function () {
    function RedirectionController() {
      _classCallCheck(this, RedirectionController);

      this._navigate = useNavigate();
    }

    _createClass(RedirectionController, [{
      key: "onDidMount",
      value: function onDidMount() {
        this._navigate(to, {
          replace: true
        });
      }
    }]);

    return RedirectionController;
  }();

  __decorate([onDidMount(), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], RedirectionController.prototype, "onDidMount", null);

  RedirectionController = __decorate([Controller({
    view: RedirectionView
  })], RedirectionController);
  return {
    path: from,
    Controller: RedirectionController,
    children: []
  };
}